(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/caretech/caretech-restrictions/assets/javascripts/active-restriction.js') >= 0) return;  svs.modules.push('/components/caretech/caretech-restrictions/assets/javascripts/active-restriction.js');
'use strict';

svs.caretech = svs.caretech || {};
svs.caretech.caretech_restrictions = svs.caretech.caretech_restrictions || {};
const {
  getFormattedDate,
  getFormattedTime
} = svs.components.lbUtils.helpers.formatDate;
const logger = svs.core.log.getLogger('components:caretech-restrictions');
const careTechRestrictionTypesEnum = {
  LONG_SESSION_RESTRICTION: 'LongSessionRestriction'
};
async function caretechTracking(action, limitData) {
  const jsonData = {
    title: 'Just nu kan du inte spela',
    body: "Du kan spela igen ".concat(getFormattedDate(limitData.to, true), " ").concat(getFormattedTime(limitData.to)),
    buttonsData: [{
      value: 0,
      text: 'Okej'
    }]
  };
  try {
    const id = crypto.randomUUID();
    await svs.core.jupiter.callAsync({
      path: '/caretech/1/track/dialoginteraction',
      method: 'POST',
      data: {
        interactionId: id,
        dialogType: limitData.restrictionMessage,
        interaction: {
          type: action,
          target: String(-1)
        },
        mandatory: limitData.dialogProperties.mandatory,
        dialogAsJson: JSON.stringify(jsonData)
      }
    });
    logger.debug("Successful sent caretech answer id: ".concat(id));
  } catch (err) {
    logger.warn("Error sending caretech answer");
  }
}
function displayTimeLimitReached(limitData) {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.SPORT,
    title: 'Just nu kan du inte spela',
    area: svs.ui.dialog.area.POPUP,
    icon: 'time-limit',
    allowDimmerClick: false,
    isGamingResponsibility: false,
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }],
    message: [{
      align: svs.ui.dialog.message.align.CENTER,
      text: "Du kan spela igen ".concat(getFormattedDate(limitData.to, true), " ").concat(getFormattedTime(limitData.to)),
      type: svs.ui.dialog.message.TEXT
    }]
  });
  svs.ui.dialog.api.add(dialog);
  caretechTracking('Displayed', limitData);
  logger.info('Displaying Hit Time Limit dialog');
  return dialog;
}
const ActiveRestriction = restriction => {
  switch (restriction === null || restriction === void 0 ? void 0 : restriction.restrictionMessage) {
    case careTechRestrictionTypesEnum.LONG_SESSION_RESTRICTION:
      displayTimeLimitReached(restriction);
      break;
    default:
      break;
  }
  return React.createElement("div", {
    className: "active-restriction"
  });
};
svs.caretech.caretech_restrictions.activeRestriction = ActiveRestriction;

 })(window);